"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Button = _interopRequireDefault(require("./Button"));
var _excluded = ["icon", "children"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var LabelButton = (0, _react.forwardRef)(function (_ref, ref) {
  var icon = _ref.icon,
    children = _ref.children,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledButton, Object.assign({
    variant: "primary",
    size: "small",
    ref: ref
  }, props), /*#__PURE__*/_react["default"].createElement(Icon, {
    className: "button-icon"
  }, icon), children);
});
var _default = exports["default"] = LabelButton;
var StyledButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "LabelButton__StyledButton",
  componentId: "sc-1skarbl-0"
})(["height:28px;z-index:1;font-family:", ";font-weight:400;color:", ";--border-color:none;border-radius:24px;text-align:center;background:rgba(0,0,0,0.5);pointer-events:none;:disabled{box-shadow:none;--border-color:none;color:", ";background:rgba(0,0,0,0.5);cursor:none;}", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontFamily.body;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.neutral['0'];
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.neutral['0'];
}, function (_ref5) {
  var disabled = _ref5.disabled;
  return !disabled && (0, _styledComponents.css)(["pointer-events:auto;:hover,:focus,:active{background:rgba(0,0,0,0.9);--border-color:none;color:", ";}"], function (_ref6) {
    var theme = _ref6.theme;
    return theme.colors.neutral['0'];
  });
});
var Icon = _styledComponents["default"].div.withConfig({
  displayName: "LabelButton__Icon",
  componentId: "sc-1skarbl-1"
})(["display:flex;flex-direction:column;align-items:center;margin-right:", ";font-size:1.6rem;> svg{width:1em;height:1em;}"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.spacing['20_Tiny'];
});
//# sourceMappingURL=LabelButton.js.map